import { BacklogCoreBase } from "./backlog.core.base"


export class BacklogCore extends BacklogCoreBase {

}